import React from 'react';
import { NoDigitalSingleSchedule, NoDigitalSlotDate } from '../types';
import { SelectedSlotData } from '../../../hooks/useNoDigitalCalendarStore';

interface NoDigitalCalendarBodyProps {
  content: NoDigitalSingleSchedule;
  selectedSlot: NoDigitalSlotDate | null;
  onSlotSelect: (slot: NoDigitalSlotDate | null, slotData?: SelectedSlotData | null) => void;
}

export const NoDigitalCalendarBody: React.FC<NoDigitalCalendarBodyProps> = ({
  content,
  selectedSlot,
  onSlotSelect,
}) => {
  const isSlotSelected = (startDate: string, endDate: string): boolean => {
    if (!selectedSlot) return false;
    return selectedSlot.startDate === startDate && selectedSlot.endDate === endDate;
  };

  const handleSlotClick = (slot: any, isAvailable: boolean) => {
    if (!isAvailable) return;
    const isCurrentlySelected = isSlotSelected(slot.startDate, slot.endDate);

    if (isCurrentlySelected) {
      onSlotSelect(null);
    } else {
      onSlotSelect({
        startDate: slot.startDate,
        endDate: slot.endDate
      }, {
        start: slot.originalStart,
        end: slot.originalEnd,
        effective_start: slot.originalEffectiveStart,
        effective_end: slot.originalEffectiveEnd,
        available_social_referents: slot.originalAvailableSocialReferents,
        type: slot.type
      });
    }
  };

  const formatTimeSlot = (startDate: string, endDate: string): string => {
    const extractTimeFromISO = (isoString: string): string => {
      // Let JavaScript handle timezone conversion automatically
      const date = new Date(isoString);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    };

    const startTime = extractTimeFromISO(startDate);
    const endTime = extractTimeFromISO(endDate);

    return `${startTime} - ${endTime}`;
  };

  return (
    <tbody>
      <tr>
        {content.map(({ daySlots }, dayIndex) => (
          <td key={`day-${dayIndex}`} className="p-2 align-top">
            <div className="space-y-2">
              {daySlots.map((slot, slotIndex) => {
                const isSelected = isSlotSelected(slot.startDate, slot.endDate);
                const isAvailable = slot.isAvailable;
                return (
                  <button
                    key={`slot-${dayIndex}-${slotIndex}`}
                    onClick={() => handleSlotClick(slot, isAvailable)}
                    disabled={!isAvailable}
                    className={`
                      w-full px-2 py-2 text-sm rounded-md border transition-colors duration-200 block
                      ${isAvailable
                        ? isSelected
                          ? 'bg-primary text-white border-primary'
                          : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400'
                        : 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                      }
                    `}
                    title={
                      isAvailable
                        ? formatTimeSlot(slot.startDate, slot.endDate)
                        : 'Slot no disponible'
                    }
                  >
                    <div className="text-center">
                      <div className="font-medium">
                        {formatTimeSlot(slot.startDate, slot.endDate)}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </td>
        ))}
      </tr>
    </tbody>
  );
};